export function formatWithCommas(num) {
  return num.toLocaleString("en-US");
}

export function formatToK(num) {
  return (num / 1000).toFixed(1);
}
